export * from '../Config/';

export const SESSION_DIALOG_YES = 'Refresh';
export const SESSION_DIALOG_NO = 'Ignore';
export const SESSION_EARLY_MINUTES = 5;
export const SESSION_FINAL_MINUTES = .5;

export const APP_RESTRICTED_PATHS = ['auth'];
